// Module
var code = "<div class=\"ka-table\"><div class=\"table\" ng-transclude ng-class=\"{'table-striped': $ctrl.striped}\"></div></div>";
// Exports
var _module_exports =code;;
var path = 'app/components/table-no-pagination/table-nop.html';
var angular = require('angular');
angular.module('pims').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
export default path;